// Module
var code = "<div class=\"contract\"> <div class=\"contractlist-container container-fluid\"> <react-contractlist watch-depth=\"one-way\"></react-contractlist> <messages></messages> </div> </div> ";
// Exports
module.exports = code;